import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/components/ui/toast';
import { useToast } from '@/hooks/use-toast';

export const Toaster = () => {
  const { toasts } = useToast();
  const toast = toasts[0]; // Only show the first/latest toast

  if (!toast) return null;

  return (
    <ToastProvider>
      <Toast key={toast.id} {...toast}>
        <div className="grid gap-1">
          {toast.title && <ToastTitle>{toast.title}</ToastTitle>}
          {toast.description && <ToastDescription>{toast.description}</ToastDescription>}
        </div>
        {toast.action}
        <ToastClose />
      </Toast>
      <ToastViewport />
    </ToastProvider>
  );
};
